import { render, staticRenderFns } from "./WysiwygViewer.vue?vue&type=template&id=0dcc5e0e&scoped=true&"
import script from "./WysiwygViewer.vue?vue&type=script&lang=ts&"
export * from "./WysiwygViewer.vue?vue&type=script&lang=ts&"
import style0 from "./WysiwygViewer.vue?vue&type=style&index=0&id=0dcc5e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc5e0e",
  null
  
)

export default component.exports